// export const API_ENDPOINT= "http://localhost:8082/recruitment/api"
export const API_ENDPOINT= process.env.REACT_APP_API_ENDPOINT;